.actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 5em;

  & > a {
    margin-left: 1em;
  }
}

.heading {
  margin-bottom: 0.8em;
}
